export interface FlightSearchRecord {
    FD_ScheduledDepartureDate: Date;
    FD_ActualDepartureDate: Date | undefined;
    FD_FlightNumber: string;
    FD_DepartureAirport: string;
    FD_DepartureTime: string;
    FD_ArrivalAirport: string;
    FD_ArrivalTime: string;
    FD_AircraftRegistration: string;
    FD_LegNumber: number | undefined;
    FD_FlightCaptain: string;
    FD_Subtype: string;
    EFB_ID: number | undefined;
    EFB_Density: number | undefined;
    EFB_OnBlockFuel: number | null | undefined;
    EFB_FuelUpliftLtr: number | null | undefined;
    EFB_FuelUpliftKg: number | null | undefined;
    EFB_OffBlockFuel: number | null | undefined;
    FSD_ID: number | undefined;
    FSD_FuelUpliftLtr: number | null | undefined;
    FSD_Density: number | null | undefined;
    FSD_FuelUpliftKg: string | null | undefined;
}
